import { platformNames } from '../constants/platform-names.contants';

export const getName = (platform, pharmacy) => {
	if (platform === platformNames.mkt) {
		return platformNames.tirxs;
	}
	return pharmacy.toUpperCase();
};
